function debounce(func, delay) {
	let timeoutId;
	return function(...args) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	};
}

function resizeCanvas(riveInstance){
	if (riveInstance && riveInstance._canvas) {
		const canvas = riveInstance._canvas;
		canvas.width = canvas.clientWidth;
		canvas.height = canvas.clientHeight;
		riveInstance?.resizeDrawingSurfaceToCanvas();
	}
}

const celebrate_anim = new rive.Rive({
	src: "/public/character_animations.riv",
	canvas: document.getElementById("celebrate-canvas"),
	autoplay: true,
	stateMachines: "Celebrate-State-Machine",
	onLoad: () => {
		resizeCanvas(celebrate_anim);
	},
});

const celebrate_anim2 = new rive.Rive({
	src: "/public/character_animations.riv",
	canvas: document.getElementById("celebrate-canvas2"),
	autoplay: true,
	artboard: "Square-Phone",
	stateMachines: "Square-Phone-State-Machine",
	onLoad: () => {
		resizeCanvas(celebrate_anim2);
	},
});

window.addEventListener("resize", debounce(() => {
	resizeCanvas(celebrate_anim);
	resizeCanvas(celebrate_anim2);
}, 250));
